import { FC } from 'react'
import { Button } from 'entities/Button'
import { withModalHOC } from 'shared/HOCs/withModalHOC'
import { ButtonContainer, ConfirmationContainer } from './styled'
import { RenderIf } from 'shared/helpers/renderIf'

export const Confirmation: FC<ConfirmationProps> = ({ onConfirm, onCancel, onClose, message }) => {
  return (
    <ConfirmationContainer>
      <p>{message}</p>
      <ButtonContainer>
        <RenderIf condition={!!onCancel}>
          <Button
            variant='outlined'
            handleClick={() => {
              onCancel()
              onClose()
            }}
          >
            Cancel
          </Button>
        </RenderIf>
        <RenderIf condition={!!onConfirm}>
          <Button
            handleClick={() => {
              onConfirm()
              onClose()
            }}
          >
            OK
          </Button>
        </RenderIf>
      </ButtonContainer>
    </ConfirmationContainer>
  )
}

type ConfirmationProps = {
  onConfirm: () => void
  onCancel: () => void
  message: string
  onClose: () => void
}

export const ConfirmationModal = withModalHOC(Confirmation)
